import React, { forwardRef } from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const VendingMedium = styled.svg`
  fill: none;
  width: 56px;
  height: 56px;
`;

const VendingMediumIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <VendingMedium
    {...props}
    ref={ref}
    viewBox="0 0 56 56"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 26C8.55228 26 9 25.5523 9 25C9 24.4477 8.55228 24 8 24V26ZM30 24C29.4477 24 29 24.4477 29 25C29 25.5523 29.4477 26 30 26V24ZM24 38C23.4477 38 23 38.4477 23 39C23 39.5523 23.4477 40 24 40V38ZM14 40C14.5523 40 15 39.5523 15 39C15 38.4477 14.5523 38 14 38V40ZM32 26V38H34V26H32ZM6 38V26H4V38H6ZM5.99966 26H8V24H5.99966V26ZM30 26H32.001V24H30V26ZM32 38H24V40H32V38ZM14 38H5.9978V40H14V38ZM4 38C4 39.1017 4.89037 40 5.9978 40V38C5.99649 38 5.99634 37.9999 5.99701 38C5.99763 38.0001 5.99835 38.0004 5.99902 38.0007C6.00027 38.0012 6.0004 38.0015 5.99998 38.0011C5.99954 38.0006 5.99958 38.0005 5.99981 38.001C5.99996 38.0014 6.00006 38.0017 6.0001 38.0019C6.00015 38.0022 6 38.0017 6 38H4ZM32 38V40C33.1046 40 34 39.1046 34 38H32ZM34 26C34 24.8967 33.1069 24 32.001 24V26H32H34ZM6 26L5.99966 26V24C4.89464 24 4 24.8959 4 26H6Z"
      fill="#00619E"
    />
    <line
      x1="9"
      y1="44"
      x2="47"
      y2="44"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="19"
      y1="48"
      x2="37"
      y2="48"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M33 37V12.5L38.5 7H47L51 10.5V39"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39 8C39 7.44772 38.5523 7 38 7C37.4477 7 37 7.44772 37 8H39ZM38 39H37C37 39.5523 37.4477 40 38 40V39ZM47 40C47.5523 40 48 39.5523 48 39C48 38.4477 47.5523 38 47 38V40ZM37 8V39H39V8H37ZM38 40H47V38H38V40Z"
      fill="#00619E"
    />
    <path
      d="M38 31L47 31"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 23L47 23"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 15L47 15"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 30C30 29.4477 29.5523 29 29 29C28.4477 29 28 29.4477 28 30H30ZM10 30C10 29.4477 9.55228 29 9 29C8.44772 29 8 29.4477 8 30H10ZM24 38C23.4477 38 23 38.4477 23 39C23 39.5523 23.4477 40 24 40V38ZM14 40C14.5523 40 15 39.5523 15 39C15 38.4477 14.5523 38 14 38V40ZM28 30V38H30V30H28ZM10 38V30H8V38H10ZM28 38H24V40H28V38ZM14 38H9.99995V40H14V38ZM8 38C8 39.1045 8.89532 40 9.99995 40V38H10H8ZM28 38H28V40C29.1047 40 30 39.1045 30 38H28Z"
      fill="#00619E"
    />
    <circle cx="19" cy="24" r="3" stroke="#00AED9" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9874 37.2565C19.1015 37.085 19.2272 36.8946 19.3624 36.6873C20.0094 35.6954 20.8693 34.3268 21.7263 32.8134C22.5866 31.294 23.4247 29.6623 24.0425 28.1394C24.6796 26.5689 25 25.3092 25 24.4706C25 20.7924 22.2146 18.007 19.0121 18C15.8125 18.0458 13.0454 20.8163 13 24.4808C13.0026 25.32 13.3233 26.5787 13.9581 28.1476C14.5762 29.675 15.4146 31.3122 16.2751 32.8371C17.1323 34.356 17.9924 35.7301 18.6395 36.726C18.7641 36.9177 18.8806 37.0951 18.9874 37.2565ZM18.0667 39.4635C18.2942 39.7715 18.6322 39.9657 19 40C19.3778 39.9664 19.7209 39.7536 19.9333 39.4212C19.9333 39.4212 27 29.4118 27 24.4706C27 19.7924 23.4183 16 19 16C14.6028 16.0534 11.0504 19.8147 11 24.4706C11 29.4118 18.0667 39.4635 18.0667 39.4635Z"
      fill="#00AED9"
    />
  </VendingMedium>
));

export default VendingMediumIcon;
